/**
 * DeviceNameLink — a device's name, linked to its profile when it has one.
 *
 * The link rule is `getDeviceProfileLink` (utils/deviceLinks.js), the same one
 * every V2 table uses: PalCare (4) and wandering tags (6) always link; Inovonics (1)
 * links except its system types (network coordinators, repeaters, locators), whose
 * profile page renders empty; anything else (e.g. SIP speakers, 10) is plain text.
 *
 * Replaces four local copies in the area and resident device drawers, two of which
 * never linked wandering tags and two of which compared manufacture_id strictly,
 * so a string id got no link (docs/DUPLICATION_AUDIT.md, B8).
 *
 * @param {object} device — needs device_id, manufacture_id, device_type_id, device_name
 * @param {string} [className] — the link's class (each drawer styles its own)
 * @param {string} [fallback] — label when device_name is blank
 */

import { Link } from 'react-router-dom';
import { getDeviceProfileLink } from '../../utils/deviceLinks.js';

const DeviceNameLink = ({ device, className, fallback = 'Unnamed Device' }) => {
  const label = device?.device_name || fallback;
  const to = getDeviceProfileLink(device);
  return to ? <Link to={to} className={className}>{label}</Link> : <>{label}</>;
};

export default DeviceNameLink;
